import cx from 'classnames';
import { Node } from 'slate';

import {
  QUOTE_DEFINITIONS,
  QUOTE_SOURCE_DEFINITIONS,
  QUOTE_TEXT_DEFINITIONS,
} from '@xing-com/content-editor-plugin-helpers';

import { QUOTE_TAG_NAME, SOURCE_TAG_NAME } from './constants';
import styles from './Quote.css';
import { QuotesIcon } from './QuotesIcon';

const quoteRenderer = ({
  node: { type },
  QUOTE_TAG = QUOTE_TAG_NAME,
  SOURCE_TAG = SOURCE_TAG_NAME,
  ...attributes
}) => {
  if (type === QUOTE_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <div
        data-editor-plugin="quote"
        className={styles.quote}
        {...restOfAttributes}
      >
        <QuotesIcon size={86} className={styles.icon} contentEditable={false} />
        {children}
      </div>
    );
  }

  if (type === QUOTE_TEXT_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return <QUOTE_TAG {...restOfAttributes}>{children}</QUOTE_TAG>;
  }

  if (type === QUOTE_SOURCE_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return <SOURCE_TAG {...restOfAttributes}>{children}</SOURCE_TAG>;
  }
};

const renderer = ({ className, ...props } = {}) => {
  const {
    node: { type },
  } = props;
  if (type === QUOTE_DEFINITIONS.type) {
    const quoteText = Node.string(Node.child(props.node, 0));

    if (quoteText.length > 0) {
      return quoteRenderer({
        className: cx(styles.quote, className),
        ...props,
      });
    }
  }

  if (
    type === QUOTE_SOURCE_DEFINITIONS.type ||
    type === QUOTE_TEXT_DEFINITIONS.type
  ) {
    return quoteRenderer({
      className: cx(styles.quote, className),
      ...props,
    });
  }
};

export { renderer };
